import React, { useEffect, useState } from "react";
import Navbar from "../components/HomeComponents/Navbar";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../helper/auth";
import { useForm } from "react-hook-form";
import { isValidPhoneNumber, isValidEmail } from "../helper/validators";
import { getInputClasses, routes } from "../helper/misc";
import Button from "../components/GeneralComponents/Button";
import SEO from "../components/Seo/Seo";
import change from "../images/change.png";
import { ReactComponent as Eye } from "../svgs/eye.svg";
import { ReactComponent as EyeOff } from "../svgs/eye-off.svg";

const loginMethods = {
  phone: "phone",
  email: "email",
};

export const Login = () => {
  const { phone, email } = loginMethods;
  const {
    formState: { errors },
    setValue,
    handleSubmit,
    register,
  } = useForm({
    defaultValues: {
      phone: "",
      password: "",
      email: "",
    },
  });
  const [loginMethod, setLoginMethod] = useState(email);
  const [showPassword, setShowPassword] = useState(false);

  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogin = (data) => {
    const payload = { password: data.password };
    if (loginMethod === email) {
      payload.email = data.email;
    } else {
      payload.phone = data.phone;
    }
    auth.login(payload);
  };

  useEffect(() => {
    if (auth.user) {
      navigate(auth.hasMeters ? routes.buy_water : routes.manage_meters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.user]);

  useEffect(() => {
    setValue("email", "");
    setValue("phone", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginMethod]);

  return (
    <div>
      <SEO type="login" title="Login" />
      <div>
        <Navbar />
        <div className="bg-[#F3F5F9] lg:mt-[-2rem] border md:rounded-3xl h-screen lg:mx-auto pb-20 lg:scale-[80%]">
          <form
            className="flex flex-col w-full lg:w-[650px] mx-auto px-3"
            onSubmit={handleSubmit(handleLogin)}
          >
            <h2 className="pt-20 font-semibold text-center text-3xl">Login</h2>
            {loginMethod === phone ? (
              <div className="w-full">
                <input
                  placeholder="Enter Phone Number"
                  className={getInputClasses(
                    !!errors.phone,
                    "mt-8 md:mt-16 w-full md:w-80 lg:w-[650px]"
                  )}
                  {...register("phone", {
                    required: true,
                    validate: isValidPhoneNumber,
                  })}
                />
                {errors.phone && (
                  <div className="text-pw-red pt-3">
                    Enter a valid phone Number
                  </div>
                )}
              </div>
            ) : (
              <div className="relative">
                <input
                  placeholder="Enter Email"
                  className={getInputClasses(
                    !!errors.email,
                    "mt-8 md:mt-16 w-full md:w-80 lg:w-[650px]"
                  )}
                  {...register("email", {
                    required: true,
                    validate: isValidEmail,
                  })}
                />
                {errors.email && (
                  <div className="text-pw-red pt-3">Enter a valid email</div>
                )}
              </div>
            )}
            <button
              type="button"
              className="text-left text-sm text-black mt-1 self-start select-none flex space-x-1 items-center"
              onClick={() =>
                setLoginMethod(loginMethod === email ? phone : email)
              }
            >
              <span>
                Login with {loginMethod === email ? "phone number" : "email"}
              </span>
              <img
                src={change}
                className="h-4"
                alt={`Login with ${
                  loginMethod === email ? "phone number" : "email"
                }`}
              />
            </button>
            <div
              className={getInputClasses(
                !!errors.password,
                "mt-8 md:mt-16 md:w-80 lg:w-[650px] !p-0 relative"
              )}
            >
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-0 pr-2 top-0 h-full items-center justify-center flex"
              >
                {showPassword ? (
                  <Eye className="h-6 w-6" />
                ) : (
                  <EyeOff className="h-6 w-6" />
                )}
              </button>
              <input
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                className="w-full h-full px-6 outline-none bg-transparent border-none py-3 focus:outline-none focus:ring-0"
                {...register("password", { required: true })}
              />
            </div>
            {errors.password && (
              <div className="text-pw-red pt-3">Enter a valid password</div>
            )}
            <button
              type="button"
              className="md:self-end"
              onClick={() => navigate(routes.forgot_password)}
            >
              <h6 className="pt-4 font-semibold text-pw-blue">
                Forgot Password ?
              </h6>
            </button>
            <Button
              text="Sign In"
              type="submit"
              loading={auth.loading}
              className={"w-full"}
            />
            <h4 className="mt-8 font-semibold">
              Don't have an account?{" "}
              <Link to="/signup">
                <span className="text-pw-blue">Sign up</span>
              </Link>
            </h4>
          </form>
        </div>
      </div>
    </div>
  );
};
